export default __webpack_public_path__ + "f18485d56b6577b33f733855744346ae.png";